// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__6kuiH","title":"BackImages_title__3vv3H","images":"BackImages_images__bQKp3"};